import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Grid,
  LoadingOverlay,
  ScrollArea,
  Select,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import { showNotification } from "@mantine/notifications";
import { UPDATE_DRIVER } from "apollo/mutuations";
import {GET_REGIONS } from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import React, { useEffect, useState } from "react";

export const DriverEditModal = ({
  activePage,
  fetchData,
  editRow,
  size,
  editId,
  setOpenedEdit,
}) => {
  const form = useForm({
    initialValues: {
      name: "",
      city: "",
      phone: "",
      region: "",
      email: "",
      password: "",
      password_confirmation: "",
    },
  });
  const [regionsDropDownData, setRegionsDropDownData] = useState([]);
  const { loading: regionsLoading } = useQuery(GET_REGIONS, {
    variables: {
      first: 100000,
      page: 1,
    },
    onCompleted(data) {
      let regions = data.regions;
      let regionsArray = [];

      regions.data.forEach((region) => {
        regionsArray.push({
          label: region?.name,
          value: region?.id.toString(), // Ensure region id is a string
        });
      });

      setRegionsDropDownData([...regionsArray]);
    },
    onError(err) {
      showNotification({
        color: "red",
        title: "Error",
        message: `${err}`,
      });
    },
  });

  const [updateDriver, { loading: driverLoading }] = useMutation(UPDATE_DRIVER);
  useEffect(() => {
    if (editRow) {
      form.setValues({
        name: editRow.user?.name || "",
        phone: editRow.user?.phone || "",
        city: editRow?.city || "",
        email: editRow?.user?.email,
        region: editRow?.region?.id?.toString() || "",
      });
    }
  }, [editRow]);

  const { height } = useViewportSize();

  const submit = () => {
    updateDriver({
      variables: {
        id: editRow.id,
        name: form.values.name,
        phone: form.values.phone,
        region_id: form.values.region.toString(),
        email: form.values.email,
        city: form.values.city,
      },
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Driver Updated Successfully",
        });
        fetchData(size, activePage);
        setOpenedEdit(false);
      },
      onError(error) {
        setOpenedEdit(false);
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to update driver",
        });
      },
    });
  };

  const setRegionDropDownValue = (val) => {
    form.setFieldValue("region", val);
  };

  return (
    <>
      <LoadingOverlay
        visible={editRow == null || driverLoading || regionsLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())}>
          <Stack>
            <Grid>
              <Grid.Col span={4}>
                <TextInput
                  required
                  label="Name"
                  placeholder="Name"
                  {...form.getInputProps("name")}
                />
                <TextInput
                  required
                  label="Phone"
                  placeholder="Phone"
                  {...form.getInputProps("phone")}
                />
                <TextInput
                  required
                  label="Email"
                  placeholder="Email"
                  {...form.getInputProps("email")}
                />
              </Grid.Col>
              <Grid.Col span={4}>
                <Select
                  required
                  data={regionsDropDownData}
                  value={form.getInputProps("region").value}
                  onChange={setRegionDropDownValue}
                  label="Region"
                  placeholder="Pick a region this driver belongs to"
                  error={form.errors.region}
                />
                <TextInput
                  required
                  label="City"
                  placeholder="City"
                  {...form.getInputProps("city")}
                />
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={6}>
                <Button
                  style={{
                    width: "25%",
                    marginTop: "15px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  type="submit"
                  fullWidth
                >
                  Submit
                </Button>
              </Grid.Col>
            </Grid>
          </Stack>
        </form>
      </ScrollArea>
    </>
  );
};
